import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import { store } from "./store";
import { Provider } from "react-redux";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import { PublicClientApplication } from "@azure/msal-browser";

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
    const root = ReactDOM.createRoot(document.getElementById("root"));
    root.render(
        <MsalProvider instance={msalInstance}>
            <BrowserRouter>
                <Provider store={store}>
                    <App />
                </Provider>
            </BrowserRouter>
        </MsalProvider>
    );
}).catch((error) => {
    console.error("MSAL initialization failed:", error);
});
